module.exports = __webpack_public_path__ + "static/media/piller_0.865c3c62.webp";